import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { Features } from './components/Features';
import { Includes } from './components/Includes';
import { ForWhom } from './components/ForWhom';
import { Benefits } from './components/Benefits';
import { ProductFormat } from './components/ProductFormat';
import { Bonuses } from './components/Bonuses';
import { EmotionalClose } from './components/EmotionalClose';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
function initMetaPixel() {
  if (window.fbq) return;
  const n: any = window.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  if (!window._fbq) window._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];
  const t = document.createElement('script');
  t.async = true;
  t.src = 'https://connect.facebook.net/en_US/fbevents.js';
  const s = document.getElementsByTagName('script')[0];
  if (s && s.parentNode) {
    s.parentNode.insertBefore(t, s);
  }
}
export function App() {
  useEffect(() => {
    initMetaPixel();
    window.fbq('init', '2158463228271631');
    window.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-cream font-sans text-charcoal selection:bg-bronze-light selection:text-charcoal" data-id="element-0">
      <Hero data-id="element-1" />
      <Features data-id="element-2" />
      <Includes data-id="element-3" />
      <ForWhom data-id="element-4" />
      <Benefits data-id="element-5" />
      <ProductFormat data-id="element-6" />
      <Bonuses data-id="element-7" />
      <EmotionalClose data-id="element-8" />
      <FAQ data-id="element-9" />
      <Footer data-id="element-10" />
    </div>;
}